const bg = "_bg_gd68h_17";
const drawer = "_drawer_gd68h_26";
const body = "_body_gd68h_60";
const drawerMenu = {
  bg,
  drawer,
  body
};
export {
  bg,
  body,
  drawerMenu as default,
  drawer
};
//# sourceMappingURL=DrawerMenu.module.css.js.map
